import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import s from "./PlusButton.module.css";
const PlusButton = forwardRef(({ isOpen, onClick }, ref) => (_jsx("button", { ref: ref, className: `${s.plusBtn}${isOpen ? ` ${s.plusBtnOpen}` : ""}`, onClick: onClick, children: "+" })));
PlusButton.displayName = "PlusButton";
export default PlusButton;
//# sourceMappingURL=PlusButton.js.map